/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AnalysisParameterDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: AnalysisParameterDefinitionDto.source;
    parameter?: string;
    analysisParameterUnit?: string;
    max?: number;
    min?: number;
    status?: AnalysisParameterDefinitionDto.status;
    categoryDefinitionId?: string;
    label?: string;
}

export namespace AnalysisParameterDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }

    export enum status {
        DELETED = 'DELETED',
        ACTIVE = 'ACTIVE',
        NURSE_OPERATION = 'NURSE_OPERATION',
        ARCHIVED = 'ARCHIVED',
        PASSIVE = 'PASSIVE',
    }


}
